import React from 'react';
import { Link } from "react-router-dom";
import { Label } from '../atoms/label';

import useMedia from 'use-media';

export const InputConfirmStartTime = (props) => {

    const isWideTablet = useMedia({ maxWidth: '960px' });
    const isWidePhone = useMedia({ maxWidth: '480px' });

    return (
        <div style={isWideTablet ? styles.inputText2 : styles.inputText}>
            <div style={isWideTablet ? styles.inputName2 : styles.inputName}>
                <Label label={props.label1} style={isWidePhone ? styles.titleSp : styles.title} />
                <div style={isWideTablet ? styles.inputTextLink : styles.inputTextLink2}>
                    <Link style={styles.link} to="/reserve/golf/startTime" >変更</Link>
                </div>
            </div>
            <div style={isWideTablet ? styles.inputTextform2 : styles.inputTextform} >
                <div style={isWideTablet ? styles.inputTextName2 : styles.inputTextName} >
                    <div style={isWideTablet ? styles.labelgloup2 : styles.labelgloup}>
                        <Label label={props.label2} style={isWideTablet ? styles.label2 : styles.label} />
                    </div>
                </div>
                <div style={isWideTablet ? styles.inputTextLink3 : styles.inputTextLink4}>
                    <Link style={styles.link} to="/reserve/golf/startTime" >変更</Link>
                </div>
            </div>
        </div>
    );
}
const styles = {
    titleSp: {
        fontSize: "1rem",
        fontWeight: "bold",
        marginBottom: "10px",
    },
    title: {
        fontSize: "1rem",
        fontWeight: "bold",
        marginBottom: "25px",
        marginLeft: 20
    },
    label: {
        textAlign: "left",
        width: "80%",
        fontWeight: "bold",
        color: "black",
        fontSize: "0.9rem",
        letterSpacing: "0.2rem",
        fontSize: "medium",
    },
    label2: {
        textAlign: "left",
        width: "80%",
        padding: "4px 0px",
        fontWeight: "bold",
        color: "black",
        fontSize: 12.6,
        letterSpacing: "0.2rem"
    },

    inputText: {
        display: "flex",
    },
    inputText2: {
        display: "block",
        width: "90%",
        margin: "0px auto",
    },
    inputName: {
        width: "40%",
    },
    inputName2: {
        width: "100%",
        display: "flex",
        justifyContent: "space-between",
    },
    inputTextform: {
        width: "70%",
        display: "flex",
    },
    labelgloup: {

        display: "flex",
    },
    labelgloup2: {
        display: "block",
        // marginBottom: "10px",
    },
    inputTextName: {
        width: "70%",
    },
    inputTextName2: {
        width: "100%",
    },
    inputTextform: {
        width: "100%",
        display: "flex",
    },
    inputTextform2: {
        width: "100%",
        display: "flex",
    },
    inputTextLink: {
        width: "30%",
        textAlign: "right",
        color: "#6f6f6f",
    },
    inputTextLink2: {
        display: "none",
    },
    inputTextLink3: {
        display: "none",
    },
    inputTextLink4: {
        width: "30%",
        textAlign: "center",
        color: "#6f6f6f",
    },
    link: {
        color: "#6f6f6f",
        fontSize: "small",
    }
}